import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Features from './components/Features/Features';
import HowToUse from './components/HowToUse/HowToUse';
import WhyChoose from './components/WhyChoose/WhyChoose';
import FAQ from './components/FAQ/FAQ';
import Contact from './components/Contact/Contact';
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import AndroidWaitlist from './components/AndroidWaitlist/AndroidWaitlist';
import AppleWaitlist from './components/AppleWaitlist/AppleWaitlist';

// Wrapper component to scroll to top on route change
const ScrollToTopOnMount = () => {
  const { pathname } = useLocation();
  
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTopOnMount />
        <Routes>
          <Route path="/android-waitlist" element={<AndroidWaitlist />} />
          <Route path="/apple-waitlist" element={<AppleWaitlist />} />
          
          {/* Main Routes */}
          <Route path="/" element={
            <>
              <Header />
              <main>
                <Hero />
              </main>
              <Footer />
            </>
          } />
          
          <Route path="/features" element={
            <>
              <Header />
              <main className="page-content">
                <Features />
                <WhyChoose />
              </main>
              <Footer />
            </>
          } />
          
          <Route path="/howitworks" element={
            <>
              <Header />
              <main className="page-content">
                <HowItWorks />
                <HowToUse />
              </main>
              <Footer />
            </>
          } />
          
          <Route path="/faq" element={
            <>
              <Header />
              <main className="page-content">
                <FAQ />
              </main>
              <Footer />
            </>
          } />
          
          <Route path="/contact" element={
            <>
              <Header />
              <main className="page-content">
                <Contact />
              </main>
              <Footer />
            </>
          } />

          <Route path="/blog" element={
            <>
              <Header />
              <main className="page-content">
                <BlogList />
              </main>
              <Footer />
            </>
          } />

          <Route path="/blog/:id" element={
            <>
              <Header />
              <main className="page-content">
                <BlogPost />
              </main>
              <Footer />
            </>
          } />
          
        </Routes>
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;
